import { Injectable } from '@jack-henry/frontend-utils/di';
import { ObservationSource } from '@jack-henry/frontend-utils/observable';
import { HeaderConfig } from './types/jhd-header-bar.type';

const defaultConfig: HeaderConfig = {
    title: '',
    subtitle: '',
    menuItems: [],
    empty: false,
    hideHeader: false,
    enableFdicSign: false,
};

Object.freeze(defaultConfig);

@Injectable()
export class HeaderBarService {
    private config: HeaderConfig = defaultConfig;

    private configSource = new ObservationSource<HeaderConfig>();

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly config$ = this.configSource.toObservable();

    private _title = '';

    private _subtitle = '';

    private _backAction?: () => void;

    public get title() {
        return this._title;
    }

    public set title(title) {
        this._title = title;
        this.configSource.emit({ ...this.config, title, subtitle: this._subtitle });
    }

    public get subtitle() {
        return this._subtitle;
    }

    public set subtitle(subtitle) {
        this._subtitle = subtitle;
        this.configSource.emit({ ...this.config, subtitle, title: this._title });
    }

    public get backAction() {
        return this._backAction;
    }

    public set backAction(backAction: HeaderConfig['backAction']) {
        this._backAction = backAction;
        this.configSource.emit({
            ...this.config,
            backAction,
            title: this._title,
            subtitle: this._subtitle,
        });
    }

    public configure(c: Partial<HeaderConfig>) {
        this.config = { ...defaultConfig, ...c };
        this.configSource.emit(this.config);
    }
}
